import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const LibraryRoom = () => {
  const [libraryData, setLibraryData] = useState(null);

  useEffect(() => {
    fetchLibraryData();
  }, []);

  const fetchLibraryData = async () => {
    const res = await facilitiesAPI.library();

    if (res.code === 200) {
      setLibraryData(res.data);
    }
  };

  const libData = libraryData?.["library-readingroom"]?.[0];

  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Library & Reading Room"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* LIBRARY SECTION */}
      {libData && (
        <>
          <section className="library-unique-section py-5">
            <div className="container">
              <div className="row align-items-stretch g-lg-5">
                <div className="col-lg-6 mb-4 mb-lg-0 animate__animated animate__fadeIn">
                  <div className="library-visual-wrapper h-100">
                    <div className="main-library-card h-100">
                      <img
                        src={libData?.image}
                        alt="Library"
                        className="img-fluid rounded-custom h-100 w-100"
                        loading="lazy"
                        style={{ objectFit: "cover" }}
                      />
                    </div>
                    <div className="decoration-box" />
                    <div className="accent-circle" />
                  </div>
                </div>
                <div className="col-lg-6 d-flex flex-column justify-content-center">
                  <div className="ps-lg-3 py-3">
                    <div className="section-intro mb-4">
                      <span className="mrv-subtitle">{libData?.title}</span>
                      <h2 className="mrv-title m-0">{libData?.subtitle}</h2>
                    </div>
                    <div className="library-feature-grid">
                      {libData?.listings?.map((item, index) => (
                        <div key={index} className="lib-item">
                          <div className="lib-icon-box">
                            <img
                              src={item.icon}
                              className="img-fluid library-icon"
                              alt={item.listingtitle}
                              loading="lazy"
                              />
                          </div>

                          <div className="lib-text">
                            <h5>{item.listingtitle}</h5>
                            <p>{item.listingdescription}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="library-reading-section py-5 bg-light">
            <div className="container">
              <div className="row align-items-center g-5">
                <div className="col-lg-6">
                  <h2 className="mrv-title">{libData?.encouragingtitle}</h2>
                  {libData?.encouragingdescription}
                </div>

                <div className="col-lg-6">
                  <img
                    src={libData?.encouragingimage}
                    alt="Library Reading"
                    className="img-fluid rounded"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default LibraryRoom;
